
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

interface IProps {
  children: React.ReactNode;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    margin: 'auto',
    width: '80vw',
    [theme.breakpoints.up('md')]: {
      width: '70vw',
    },
    [theme.breakpoints.up('lg')]: {
      width: '50vw',
    },
  },
});

/**
 * Komponent som ändrar bredd beroende på viewport-bredd, kan vara bra att
 * använda i tex Modals om man vill att innehållet ska ta upp lite mer plats
 */
export const EDViewportWidthContainer: React.FC<
  React.PropsWithChildren<IProps>
> = props => <div className={props.classes.container}>{props.children}</div>;

export default withStyles(EDViewportWidthContainer, styles);
